export function hasCommonElements(arr1: string[], arr2: string[]) {
    return arr1.map((a) => a?.toLowerCase()).some((item) => arr2?.map((a) => a?.toLowerCase()).includes(item));
}
